// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { AICompanyKpiTemplateFields, SaaSCompanyKpiTemplateFields, TemplateType } from 'common/report/dashboards/types';
import { Translatable } from 'common/i18n';
export enum RHSPanelMode {
  StarterBoard = `starter-board`,
  Templates = `templates`,
}
export interface RHSPanelState {
  fields: { [key in TemplateField]?: any } | EmptyObj;
  calendarInputOpen?: boolean;
  tutorialCurrentStepIndex: number;
  showTutorial: boolean;
  hideTutorial: boolean;
}
export interface RHSPanelProps {
  params?: RHSPanelParams;
  on?: {
    updateBlueprint?: (ev: CustomEvent<any>) => void;
    commitBlueprint?: (ev: CustomEvent<any>) => void;
    clickSeeAllTemplates?: (ev: CustomEvent<any>) => void;
  };
}
export interface RHSPanelParams {
  mode: RHSPanelMode;
  selectedTemplate?: TemplateType;
  isLoading?: boolean;
  isSeeAllTemplatesLoading?: boolean;
  showReminderTooltip?: boolean;
}
export type MoreInfoConfig = {
  text: string;
  link: string;
};
export enum RHSInputType {
  Event = `event`,
  Property = `property`,
  Date = `date`,
  List = `list`,
  Key = `key`,
  Text = `text`,
}
export type TemplateCard = {
  title: string;
  templateSelectDescription: string;
  imageId: string;
  eventSelectStepDescription: string;
  requiredFieldsCheck: () => boolean;
  demoBoardLink?: string;
  moreInfo?: MoreInfoConfig;
};
export type TemplateField = KPITemplateFields | ProductLaunchTemplateFields | LifecycleCohortAnalysisTemplateFields | MarketingKPITemplateFields | ECommerceTemplateFields | WebAnalyticsTemplateFields | BenchmarkKPITemplateFields | SaaSCompanyKpiTemplateFields | AICompanyKpiTemplateFields;
export enum KPITemplateFields {
  SIGN_UP = `Sign Up`,
  VALUE_MOMENT = `Value Moment`,
}
export enum BenchmarkKPITemplateFields {
  SIGN_UP = `Sign Up`,
  VALUE_MOMENT = `Value Moment`,
  INDUSTRY = `Industry`,
}
export enum ProductLaunchTemplateFields {
  FEATURE_NAME = `Feature Name`,
  LAUNCH_DATE = `Launch Date`,
  NEW_FEATURE = `New Feature`,
  FEATURE_VALUE_MOMENT = `Feature Value Moment`,
}
export enum LifecycleCohortAnalysisTemplateFields {
  VALUE_MOMENT = `Value Moment`,
}
export enum MarketingKPITemplateFields {
  ACTIVATION_EVENT = `Activation Event`,
  CONVERSION_EVENT = `Conversion Event`,
}
export enum ECommerceTemplateFields {
  SIGN_UP_EVENT = `EComm Sign Up`,
  PURCHASE_EVENT = `Purchase`,
  ADD_TO_CART_EVENT = `Add to Cart`,
  PRODUCT_VIEWED_EVENT = `Product Viewed`,
  CART_PROPERTY = `Cart Property`,
  CART_PROPERTY_2 = `Cart Property 2`,
  PRICE_KEY = `Price Key`,
  CATEGORY_KEY = `Category Key`,
  AD_SPEND_EVENT = `Ad Spend Event`,
  AD_COST_PROPERTY = `Ad Cost`,
}
export enum WebAnalyticsTemplateFields {
  PAGE_LOADED_EVENT = `Page Loaded`,
  PAGE_NAME_PROPERTY = `Page Name`,
}
export const TemplateFieldLabelTranslation = {
  [KPITemplateFields.SIGN_UP]: ({
    t
  }) => t(`boards.rhs.kpi.label.sign-up`),
  [KPITemplateFields.VALUE_MOMENT]: ({
    t
  }) => t(`boards.rhs.kpi.label.value-moment`),
  [BenchmarkKPITemplateFields.INDUSTRY]: ({
    t
  }) => t(`boards.rhs.benchmark.label.industry`),
  [ProductLaunchTemplateFields.FEATURE_NAME]: ({
    t
  }) => t(`boards.rhs.product-launch.label.feature-name`),
  [ProductLaunchTemplateFields.LAUNCH_DATE]: ({
    t
  }) => t(`boards.rhs.product-launch.label.launch-date`),
  [ProductLaunchTemplateFields.NEW_FEATURE]: ({
    t
  }) => t(`boards.rhs.product-launch.label.new-feature`),
  [ProductLaunchTemplateFields.FEATURE_VALUE_MOMENT]: ({
    t
  }) => t(`boards.rhs.product-launch.label.feature-value-moment`),
  [MarketingKPITemplateFields.ACTIVATION_EVENT]: ({
    t
  }) => t(`boards.rhs.marketing-kpi.label.activation`),
  [MarketingKPITemplateFields.CONVERSION_EVENT]: ({
    t
  }) => t(`boards.rhs.marketing-kpi.label.conversion`),
  [ECommerceTemplateFields.PURCHASE_EVENT]: ({
    t
  }) => t(`boards.rhs.ecommerce.label.purchase`),
  [ECommerceTemplateFields.ADD_TO_CART_EVENT]: ({
    t
  }) => t(`boards.rhs.ecommerce.label.add-to-cart`),
  [ECommerceTemplateFields.PRODUCT_VIEWED_EVENT]: ({
    t
  }) => t(`boards.rhs.ecommerce.label.product-viewed`),
  [ECommerceTemplateFields.CART_PROPERTY]: ({
    t
  }) => t(`boards.rhs.ecommerce.label.cart`),
  [ECommerceTemplateFields.CART_PROPERTY_2]: ({
    t
  }) => t(`boards.rhs.ecommerce.label.cart`),
  [ECommerceTemplateFields.PRICE_KEY]: ({
    t
  }) => t(`boards.rhs.ecommerce.label.price`),
  [ECommerceTemplateFields.CATEGORY_KEY]: ({
    t
  }) => t(`boards.rhs.ecommerce.label.category`),
  [ECommerceTemplateFields.SIGN_UP_EVENT]: ({
    t
  }) => t(`boards.rhs.ecommerce.label.sign-up`),
  [ECommerceTemplateFields.AD_SPEND_EVENT]: ({
    t
  }) => t(`boards.rhs.ecommerce.label.ad-spend`),
  [ECommerceTemplateFields.AD_COST_PROPERTY]: ({
    t
  }) => t(`boards.rhs.ecommerce.label.ad-cost-property`),
  [WebAnalyticsTemplateFields.PAGE_LOADED_EVENT]: ({
    t
  }) => t(`boards.rhs.web-analytics.label.page-loaded`),
  [WebAnalyticsTemplateFields.PAGE_NAME_PROPERTY]: ({
    t
  }) => t(`boards.rhs.web-analytics.label.page-name`),
  [SaaSCompanyKpiTemplateFields.MRR_PROPERTY_FIELD]: ({
    t
  }) => t(`boards.rhs.saas-company-kpi.label.mrr`),
  [SaaSCompanyKpiTemplateFields.SEGMENT_PROPERTY_FIELD]: ({
    t
  }) => t(`boards.rhs.saas-company-kpi.label.segment`),
  [SaaSCompanyKpiTemplateFields.PLAN_TYPE_PROPERTY_FIELD]: ({
    t
  }) => t(`boards.rhs.saas-company-kpi.label.plan-type`),
  [AICompanyKpiTemplateFields.AI_SUBMIT_PROMPT_EVENT_FIELD]: ({
    t
  }) => t(`boards.rhs.ai-company-kpi.label.llm-prompt-event`),
  [AICompanyKpiTemplateFields.AI_PROMPT_PROPERTY_FIELD]: ({
    t
  }) => t(`boards.rhs.ai-company-kpi.label.llm-prompt-text`),
  [AICompanyKpiTemplateFields.AI_RESPONSE_SENT_EVENT_FIELD]: ({
    t
  }) => t(`boards.rhs.ai-company-kpi.label.llm-response-event`),
  [AICompanyKpiTemplateFields.AI_RESPONSE_COST_PROPERTY_FIELD]: ({
    t
  }) => t(`boards.rhs.ai-company-kpi.label.api-cost`),
  [AICompanyKpiTemplateFields.AI_RESPONSE_TIME_PROPERTY_FIELD]: ({
    t
  }) => t(`boards.rhs.ai-company-kpi.label.response-time`),
  [AICompanyKpiTemplateFields.AI_TOKENS_USED_PROPERTY_FIELD]: ({
    t
  }) => t(`boards.rhs.ai-company-kpi.label.tokens-used`),
  [AICompanyKpiTemplateFields.AI_START_AGENT_EVENT_FIELD]: ({
    t
  }) => t(`boards.rhs.ai-company-kpi.label.start-agent`),
  [AICompanyKpiTemplateFields.AI_AGENT_DISMISSED_EVENT_FIELD]: ({
    t
  }) => t(`boards.rhs.ai-company-kpi.label.agent-dismissed`),
  [AICompanyKpiTemplateFields.AI_API_ERROR_EVENT_FIELD]: ({
    t
  }) => t(`boards.rhs.ai-company-kpi.label.api-error`),
  [AICompanyKpiTemplateFields.AI_USER_FEEDBACK_EVENT_FIELD]: ({
    t
  }) => t(`boards.rhs.ai-company-kpi.label.user-feedback-event`),
  [AICompanyKpiTemplateFields.AI_USER_FEEDBACK_SENTIMENT_PROPERTY_FIELD]: ({
    t
  }) => t(`boards.rhs.ai-company-kpi.label.user-feedback-sentiment`),
  [AICompanyKpiTemplateFields.AI_USER_FEEDBACK_TEXT_PROPERTY_FIELD]: ({
    t
  }) => t(`boards.rhs.ai-company-kpi.label.user-feedback-text`)
};
export type TutorialStep = {
  nextStepIndex?: number;
  stepInfo: Translatable;
};
export type TUTORIAL_FINISHED = `Tutorial Finished`;
export type TutorialConfig = { [key in TemplateField | TUTORIAL_FINISHED]?: TutorialStep };
export const ECOMMERCE_TUTORIAL_CONFIG: TutorialConfig = {
  [ECommerceTemplateFields.SIGN_UP_EVENT]: {
    nextStepIndex: 1,
    stepInfo: ({
      t
    }) => t(`boards.rhs.ecommerce.tutorial.sign-up`)
  },
  [ECommerceTemplateFields.PURCHASE_EVENT]: {
    nextStepIndex: 2,
    stepInfo: ({
      t
    }) => t(`boards.rhs.ecommerce.tutorial.purchase`)
  },
  [ECommerceTemplateFields.CART_PROPERTY]: {
    nextStepIndex: 3,
    stepInfo: ({
      t
    }) => t(`boards.rhs.ecommerce.tutorial.cart`)
  },
  [ECommerceTemplateFields.PRICE_KEY]: {
    nextStepIndex: 4,
    stepInfo: ({
      t
    }) => t(`boards.rhs.ecommerce.tutorial.price`)
  },
  [ECommerceTemplateFields.ADD_TO_CART_EVENT]: {
    nextStepIndex: 5,
    stepInfo: ({
      t
    }) => t(`boards.rhs.ecommerce.tutorial.add-to-cart`)
  },
  [ECommerceTemplateFields.CART_PROPERTY_2]: {
    nextStepIndex: 6,
    stepInfo: ({
      t
    }) => t(`boards.rhs.ecommerce.tutorial.cart`)
  },
  [ECommerceTemplateFields.CATEGORY_KEY]: {
    nextStepIndex: 7,
    stepInfo: ({
      t
    }) => t(`boards.rhs.ecommerce.tutorial.category`)
  },
  [ECommerceTemplateFields.PRODUCT_VIEWED_EVENT]: {
    nextStepIndex: 8,
    stepInfo: ({
      t
    }) => t(`boards.rhs.ecommerce.tutorial.product-viewed`)
  },
  [ECommerceTemplateFields.AD_SPEND_EVENT]: {
    nextStepIndex: 9,
    stepInfo: ({
      t
    }) => t(`boards.rhs.ecommerce.tutorial.ad-spend`)
  },
  [ECommerceTemplateFields.AD_COST_PROPERTY]: {
    stepInfo: ({
      t
    }) => t(`boards.rhs.ecommerce.tutorial.ad-cost`),
    nextStepIndex: 10
  },
  'Tutorial Finished': {
    stepInfo: ({
      t
    }) => t(`boards.rhs.ecommerce.tutorial.finished`)
  }
};
export const ADVANCED_TEMPLATE_TYPES_TO_TUTORIAL_MAP: Map<TemplateType, TutorialConfig> = new Map([[TemplateType.E_COMMERCE, ECOMMERCE_TUTORIAL_CONFIG]]); // add more advanced template types here

export const LEARN_MORE_LINK_MAP: Map<TemplateType, string> = new Map([[TemplateType.E_COMMERCE, `https://mixpanel.com/blog/mixpanel-ecommerce-analytics/`]]); // add more advanced template types here

/**
 * Maps Template Fields Enum values to standardized event types used by event categorization.
 * This is necessary because some template field values differ from the standardized event types
 * (e.g., "EComm Sign Up" -> "Sign Up").
 *
 * Standardized event types are defined in:
 * api/version_2_0/data_definitions/event_name_categorization/event_types.py
 */
export function mapTemplateFieldToEventType(templateField: TemplateField): string {
  // Handle special cases where template field value differs from standardized event type
  if (templateField === ECommerceTemplateFields.SIGN_UP_EVENT) {
    return KPITemplateFields.SIGN_UP;
  }

  // For all other fields, return the value as-is since they match the standardized event types
  return templateField;
}